import type { IconData } from '@stacksjs/iconify-core'

export const smileyDroolFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M24 1.5C11.574 1.5 1.5 11.574 1.5 24S11.574 46.5 24 46.5S46.5 36.426 46.5 24S36.426 1.5 24 1.5\"/><path fill=\"#2859c5\" fill-rule=\"evenodd\" d=\"M12.925 19.547c.497-1.752 2.497-2.95 4.585-2.423a2 2 0 1 0 .98-3.877c-4.009-1.015-8.277 1.203-9.413 5.207a2 2 0 1 0 3.848 1.093m17.565-2.423c2.088-.528 4.088.671 4.585 2.423a2 2 0 1 0 3.848-1.093c-1.136-4.005-5.404-6.222-9.414-5.207a2 2 0 1 0 .98 3.877Zm1.01 20.612a3 3 0 0 0 5-2.236V27a2.5 2.5 0 0 0-1.572-2.322l-.186.464l.186-.464a2.5 2.5 0 0 0-.926-.178H13.998c-1.354 0-2.569 1.124-2.326 2.574C12.66 32.991 17.803 37.5 24 37.5q.251 0 .5-.01V39a3.5 3.5 0 1 0 7 0z\" clip-rule=\"evenodd\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default smileyDroolFlat
